import { Link as RouterLink } from 'react-router-dom';
import { styled } from 'styled-components';

import { CssVariable } from '../../../styles/cssTypes';

type LinkProps = {
  'data-active': boolean;
};

/**
 * Get the button background color
 *
 * @param props Props passed to the component
 * @returns     The variable to use
 */
const getColorBackground = (props: LinkProps): CssVariable => {
  if (props['data-active']) {
    return 'var(--color-hover)';
  }

  return 'var(--color-background)';
};

/**
 * Determining which color the border will be
 *
 * @param props Props passed to the component
 * @returns     The variable to use
 */
const getColorBorder = (props: LinkProps): CssVariable => {
  if (props['data-active']) {
    return 'var(--color-text-selected)';
  }

  return 'var(--color-border-dark)';
};

/**
 * Get which color to use for the text
 *
 * @param props The props passed to the wrapper
 * @returns     The variable to use
 */
const getColorText = (props: LinkProps): CssVariable => {
  if (props['data-active']) {
    return 'var(--color-text-selected)';
  }

  return 'var(--color-text-light)';
};

export const Link = styled(RouterLink)<LinkProps>`
  background-color: ${getColorBackground};
  border: var(--border-dark);
  border-color: ${getColorBorder};
  border-radius: var(--border-radius-small);
  color: ${getColorText};
  display: inline-flex;
  font-size: var(--font-sm);
  font-weight: 600;
  padding: var(--spacing-tiny);
  white-space: nowrap;
`;
